export const getLastOpenDialog = (): HTMLElement | null => {
  const dialogs = document.querySelectorAll('dialog[open]');
  if (dialogs.length === 0) return null;

  return dialogs[dialogs.length - 1] as HTMLElement;
};
